import React from 'react';
import PropTypes from 'prop-types';

import { textProps, textClass } from '../utilities/text';
import { colorsProps, colorsClass } from '../utilities/colors';
import { bordersProps, bordersClass } from '../utilities/borders';

import cn from 'classnames';

const CardFooter = (props) => {
  let { tag: Tag, className, children, onClick, ...attributes } = props;

  let text, colors, borders;
  [text, attributes] = textClass(attributes);
  [colors, attributes] = colorsClass(attributes);
  [borders, attributes] = bordersClass(attributes);

  return (
    <Tag
      {...attributes}
      className={cn('card-footer', text, colors, borders, className)}
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};

CardFooter.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  ...textProps(),
  ...colorsProps(),
  ...bordersProps(),
};

CardFooter.defaultProps = {
  tag: 'footer',
  className: '',
  // bgColor: 'orange',
  // txtColor: 'white',
  txtAlign: 'center',
  txtTrans: 'uppercase',
  fontWeight: 'bold',
};

export default CardFooter;
